import __request__ from 'routing/request';
type FileArray = File[];
interface CreateClientCertRequest {
    readonly principal: string;
    readonly password: string;
    readonly role: string;
}
interface CreateCARequest {
    readonly organization: string;
}
interface CA {
    readonly id: string;
    readonly type: 'GENERATED' | 'LOCAL' | 'UPLOADED';
}
/**
 * Returns the CA
 */
export function get(): Promise<CA> {
    return __request__('GET', '/ca', null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Creates a client certificate
 */
export function createClientCert(request: CreateClientCertRequest): Promise<unknown> {
    return __request__('POST', '/ca/clientcert', request, {}, {
        'Accept': ['application/json']
    });
}
/**
 * removes the cert and the user from the role
 */
export function deleteClientCert(role: string, principal: string): Promise<unknown> {
    return __request__('DELETE', `/ca/clientcert/${role}/${principal}`, null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Creates a CA
 */
export function createCA(request: CreateCARequest): Promise<void> {
    return __request__('POST', '/ca/create', request, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Upload a CA
 */
export function uploadCA(password?: string, files?: FileArray): Promise<unknown> {
    const formData = new FormData();
    formData.append("password", password);
    files.forEach(f => formData.append("files", f));
    return __request__('POST', '/ca/upload', formData, {}, {
        'Accept': ['application/json']
    });
}
